
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-plus",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.603 14.4V.797h3.201V14.4h13.603v3.201H16.804v13.603h-3.201V17.601H0V14.4h13.603z"}})])
          )
        }
      }
    